import {
    Grid,
    TextField,
    Typography,
    Box
} from "@mui/material";
import { OneSwitch } from "../OneSwitch/OneSwitch";
import { useEffect, useState } from "react";

const HorariosSemana = ({
    horarios,
    setHorarios
}) => {
    const [SegundoHorarioAtivo, setSegundoHorarioAtivo] = useState(false)

    if (!Array.isArray(horarios)) {
        return <Typography>Carregando horários...</Typography>;
    }

    useEffect(() => {
        if (!horarios || horarios.length === 0) return

        const existeSegundoHorario = horarios.some(dia =>
            (dia.ini2 && dia.ini2 !== '') ||
            (dia.fim2 && dia.fim2 !== '')
        )

        setSegundoHorarioAtivo(existeSegundoHorario)
    }, [])

    const handleSegundoHorarioAtivo = () => {
        setSegundoHorarioAtivo(!SegundoHorarioAtivo)
    }

    const handleSwitchChange = (index) => {
        setHorarios(prev =>
            prev.map((h, i) =>
                i === index ? { ...h, ativo: !h.ativo } : h
            )
        );
    };

    const handleTimeChange = (index, campo, valor) => {
        setHorarios(prev =>
            prev.map((h, i) =>
                i === index ? { ...h, [campo]: valor } : h
            )
        );
    };

    return (
        <Box p={1}>
            {/* Switch geral */}
            <Grid container alignItems="center" mb={2} p={1}>
                <Grid item xs={2.6} sm={2.6}>
                    <Typography>Segundo Horário</Typography>
                </Grid>

                <Grid item xs={6} sm={2}>
                    <OneSwitch
                        checked={SegundoHorarioAtivo}
                        onChange={handleSegundoHorarioAtivo}
                    />
                </Grid>
            </Grid>

            {/* Dias da semana */}
            {
                horarios.map((dia, index) => (
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        key={dia.key}
                        sx={{ mb: 2, p: 1 }}
                    >
                        {/* Dia */}
                        <Grid item xs={1.5} sm={1.5}>
                            <Typography>{dia.nome}</Typography>
                        </Grid>

                        {/* Switch do dia */}
                        <Grid item xs={1} sm={1}>
                            <OneSwitch
                                checked={dia.ativo}
                                onChange={() => handleSwitchChange(index)}
                            />
                        </Grid>

                        {/* Início */}
                        <Grid item xs={2.3} sm={SegundoHorarioAtivo ? 2.3 : 2.3}>
                            <TextField
                                fullWidth
                                label="Início"
                                type="time"
                                size="small"
                                disabled={!dia.ativo}
                                value={dia.inicio}
                                onChange={(e) =>
                                    handleTimeChange(index, "inicio", e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        {/* Fim */}
                        <Grid item xs={2.3} sm={SegundoHorarioAtivo ? 2.3 : 2.3}>
                            <TextField
                                fullWidth
                                label="Fim"
                                type="time"
                                size="small"
                                disabled={!dia.ativo}
                                value={dia.fim}
                                onChange={(e) =>
                                    handleTimeChange(index, "fim", e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        {/* Segundo horário */}
                        {SegundoHorarioAtivo && (
                            <>
                                <Grid item xs={2.3} sm={2.3}>
                                    <TextField
                                        fullWidth
                                        label="Início"
                                        type="time"
                                        size="small"
                                        disabled={!dia.ativo}
                                        value={dia.ini2 || ""}
                                        onChange={(e) =>
                                            handleTimeChange(index, "ini2", e.target.value)
                                        }
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={2.3} sm={2.3}>
                                    <TextField
                                        fullWidth
                                        label="Fim"
                                        type="time"
                                        size="small"
                                        disabled={!dia.ativo}
                                        value={dia.fim2 || ""}
                                        onChange={(e) =>
                                            handleTimeChange(index, "fim2", e.target.value)
                                        }
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                ))
            }
        </Box >
    );
};

export default HorariosSemana;
